var _path, _path2, _path3, _path4, _path5, _path6, _path7;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCreditCardActive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 31,
    viewBox: "0 0 46 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.8284 0.85H4.97816C2.70206 0.85 0.85 2.70155 0.85 4.97816V8.10891V14.2078V26.0995C0.85 28.3761 2.70204 30.2281 4.97816 30.2281H40.8284C43.105 30.2281 44.957 28.3761 44.957 26.0995V14.2078V8.10891V4.97816C44.957 2.70154 43.1049 0.85 40.8284 0.85ZM4.97816 2.12349H40.8284C42.4024 2.12349 43.6835 3.40463 43.6835 4.97816V7.47216H2.12349V4.97816C2.12349 3.40414 3.4046 2.12349 4.97816 2.12349ZM43.6835 13.5711H2.12349V8.74565H43.6835V13.5711ZM40.8284 28.9546H4.97816C3.40461 28.9546 2.12349 27.674 2.12349 26.0995V14.8446H43.6835V26.0995C43.6835 27.674 42.4024 28.9546 40.8284 28.9546Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6792 19.85H6.32083C6.16388 19.85 6.04255 19.9488 5.96778 20.0653C5.89198 20.1833 5.85 20.3374 5.85 20.5C5.85 20.6626 5.89198 20.8167 5.96778 20.9347C6.04255 21.0512 6.16388 21.15 6.32083 21.15H18.6792C18.8362 21.15 18.9576 21.0512 19.0324 20.9347C19.1081 20.8166 19.15 20.6625 19.15 20.5C19.15 20.3375 19.1081 20.1834 19.0324 20.0653C18.9576 19.9488 18.8362 19.85 18.6792 19.85Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6338 19.85H21.4867C21.1347 19.85 20.85 20.1347 20.85 20.4867C20.85 20.8388 21.1347 21.1235 21.4867 21.1235H23.5603H25.6338C25.9858 21.1235 26.2706 20.8388 26.2706 20.4867C26.2706 20.1347 25.9858 19.85 25.6338 19.85Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.3
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.3346 22.85H19.6654C19.4521 22.85 19.2534 22.9146 19.1046 23.0264C18.9557 23.1383 18.85 23.3042 18.85 23.5C18.85 23.6958 18.9557 23.8617 19.1046 23.9736C19.2534 24.0854 19.4521 24.15 19.6654 24.15H22.5H25.3346C25.5479 24.15 25.7466 24.0854 25.8954 23.9736C26.0443 23.8617 26.15 23.6958 26.15 23.5C26.15 23.3042 26.0443 23.1383 25.8954 23.0264C25.7466 22.9146 25.5479 22.85 25.3346 22.85Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.3
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5247 22.85H12.4753C12.1225 22.85 11.85 23.1479 11.85 23.5C11.85 23.8521 12.1225 24.15 12.4753 24.15H14.5H16.5247C16.8775 24.15 17.15 23.8521 17.15 23.5C17.15 23.1479 16.8775 22.85 16.5247 22.85Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.3
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9.61977 22.85H6.38023C6.21831 22.85 6.0824 22.9365 5.99187 23.0555C5.90145 23.1744 5.85 23.332 5.85 23.5C5.85 23.668 5.90145 23.8256 5.99187 23.9445C6.0824 24.0635 6.21831 24.15 6.38023 24.15H8H9.61977C9.78169 24.15 9.9176 24.0635 10.0081 23.9445C10.0985 23.8256 10.15 23.668 10.15 23.5C10.15 23.332 10.0985 23.1744 10.0081 23.0555C9.9176 22.9365 9.78169 22.85 9.61977 22.85Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.3
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M34.5 19.65H38.5C39.5217 19.65 40.35 20.4783 40.35 21.5C40.35 22.5217 39.5217 23.35 38.5 23.35H34.5C33.4783 23.35 32.65 22.5217 32.65 21.5C32.65 20.4783 33.4783 19.65 34.5 19.65Z",
    fill: "#008A80",
    stroke: "white",
    strokeWidth: 1.3
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreditCardActive);
export default __webpack_public_path__ + "static/media/creditCardActive.7cbdf53c8d13defb6d9da9537e1281e3.svg";
export { ForwardRef as ReactComponent };